import { LogisticDocument } from "src/app/document/model/logistic-document";

export class Box {
    public _id!: string;
    public boxModelId!: string;
    public closed: boolean = false;
    public documentList: LogisticDocument[] = [];
}